import { render, staticRenderFns } from "./CommissionsDetailsOptions.vue?vue&type=template&id=0f9cb99a&scoped=true&"
import script from "./CommissionsDetailsOptions.vue?vue&type=script&lang=js&"
export * from "./CommissionsDetailsOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9cb99a",
  null
  
)

export default component.exports